<template>
  <CompanyAutocomplete
    class="w-full"
    :search-size="5"
    size="lg"
  />
</template>
